/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react'
import {ButtonProps} from "@mui/material/Button";
import {Button} from "@mui/material";
import {styled} from "@mui/material/styles";
import {theme} from "../../../constants/theme";
import {LoadingButton} from "@mui/lab";
import Loader from "../Loader/Loader";

interface IProps extends ButtonProps {
  fontSize?: number
  isLoadingButton?: boolean
  isLoading?: boolean
  loaderSize?: number | string
}

const StyledButton = styled(Button)<IProps>((props) => ({
  fontSize: props?.fontSize ?? theme.font.button.size,
  whiteSpace: 'nowrap',
}));

const StyledLoadingButton = styled(LoadingButton)<IProps>((props) => ({
  fontSize: props?.fontSize ?? theme.font.button.size,
  whiteSpace: 'nowrap',
  maxWidth: 'max-content',
}));

const ArgosButton = (props: IProps) => {
  const {children, isLoadingButton, isLoading, ...buttonOnlyProps} = props
  return (
    <>
      {
        !isLoadingButton ?
          <StyledButton
            variant={'outlined'}
            color="primary"
            size={"small"}
            {...buttonOnlyProps}
          >
            {children}
          </StyledButton>
          :
          <StyledLoadingButton
            loading={isLoading}
            loadingPosition={'end'}
            variant={'outlined'}
            color="primary"
            size={"small"}
            {...buttonOnlyProps}
          >
            {children}
          </StyledLoadingButton>
      }
    </>
  )
}

export const ArgosLoadingButton = (props: IProps) => {
  const {children, isLoadingButton, isLoading, ...buttonOnlyProps} = props
  return (
    <StyledButton
      variant={'outlined'}
      color="primary"
      size={"small"}
      {...buttonOnlyProps}
      disabled={isLoading || (props.disabled ?? false)}
    >
      {children}
      <Loader wrapperStyle={{marginLeft: 3}} isLoading={isLoading ?? false} loaderSize={props.loaderSize ?? 20}/>
    </StyledButton>
  )
}

export default ArgosButton